<main>
  <h2>{{sistema}} - {{action}} Vinculação</h2>
  <form *ngIf="form" [formGroup]="form" (ngSubmit)="salvar()" class="row g-0" (keydown.enter)="$event.preventDefault()">
    <label class="col-4"  [ngClass]="{'mb-0': validate || errorValidate}">
      <b>Número do Processo <sup class="text-danger">*</sup></b>
      <input type="text" class="form-control" maxlength="17" formControlName="numero_processo" 
        placeholder="Número do processo">
    </label>
    <button class="col-1 mt-auto ms-2 btn btn-primary" type="button" [ngClass]="{'mb-0': validate || errorValidate}"
      *ngIf="this.type != 'edit'" (click)="check()">Validar</button>
    <div class="col-12" *ngIf="this.type == 'edit'"></div>
    <b class="success" *ngIf="validate">Processo válido!</b>
    <b class="text-danger" *ngIf="!validate && errorValidate"> {{errorValidate}}</b>
    <label class="col-8">
      <b>Descrição</b>
      <textarea class="form-control" maxlength="255" formControlName="descricao" placeholder="Digite a descrição do processo"></textarea>
    </label>
    <div formArrayName="pf_processo_vinculo">
      <h3>Vínculos</h3>
      <div class="col-8 row g-0" *ngFor="let vinculo of getVinculos()?.controls ?? []; let i = index" [formGroupName]="i">
        <label class="col-4">
          <b>Tipo de Vínculo</b>
          <ng-select id="tipo_vinculacao" [items]="tipoVinculacao" bindValue="id" bindLabel="label"
            placeholder="Seleciona o tipo de Vínculo" formControlName="tipo_vinculacao"></ng-select>
        </label>
        <label class="col-4 ms-2">
          <b>Vínculo</b>
          <ng-select id="item_id" [items]="getComboLink(vinculo)" bindLabel="label" bindValue="id"
            placeholder="Selecione um Vínculo" formControlName="item_id"></ng-select>
        </label>
        <button class="btn btn-danger font-icon ms-2 mt-auto col-1" type="button" (click)="removeVinculo(i)">delete</button>
      </div>
      <button type="button" (click)="newVinculo()" class="btn btn-primary">Adicionar vinculo</button>
    </div>
    <hr class="final-line">
    <footer class="form-group row d-flex justify-content-end">
      <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
      <button class="btn btn-danger m-r-xs" type="button"
        *ngIf="this.type == 'edit'" (click)="deletar()">Deletar</button>
        <button class="btn btn-white m-r-xs" type="button" (click)="voltar()" alt="Voltar">Voltar</button>
        <button class="btn btn-primary" type="submit" alt="Salvar reunião">Salvar</button>
      </div>
    </footer>
  </form>
</main>
<app-loading [loader]="isLoading"></app-loading>